import { render, staticRenderFns } from "./CallsMobile.vue?vue&type=template&id=aaf1f342&"
import script from "./CallsMobile.vue?vue&type=script&lang=js&"
export * from "./CallsMobile.vue?vue&type=script&lang=js&"
import style0 from "./CallsMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports